import { useEffect, useState } from 'react';

/**
 * Check meta tag for share loop tracking params, if
 * <meta name="share-loop-tracking-params" content="1" /> exists in head, hasShareLoopTrackingParams will be true
 * TODO: remove this hook after Share Loop is fully rolled out
 */
export const useShareLoopParams = () => {
  const [hasShareLoopTrackingParams, setHasShareLoopTrackingParams] = useState<boolean | null>(
    null,
  );

  useEffect(() => {
    const releaseMetaTag = document.querySelector('meta[name="share-loop-tracking-params"]');

    if (releaseMetaTag?.getAttribute('content') === '1') {
      setHasShareLoopTrackingParams(true);
    } else {
      setHasShareLoopTrackingParams(false);
    }
  }, []);

  return { hasShareLoopTrackingParams };
};
